module.exports = __webpack_public_path__ + "static/img/product_20.91b5dee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_20.jpg
// module id = 8wBw
// module chunks = 2